import { ChangeDetectionStrategy, Component, OnDestroy } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { take, takeUntil } from 'rxjs/operators'
import { Store } from '@ngrx/store'
import { navigate } from '@adex/store/actions/global.actions'
import { verifyAccount } from '@adex/store/actions/auth.actions'
import { appRoutes } from '@adex/shared/routing/routes'
import { Subject } from 'rxjs'
import { selectQueryParam } from '@adex/store/selectors'


@Component({
  selector: 'adex-confirmation-container',
  templateUrl: './confirmation-container.component.html',
  styleUrls: [ './confirmation-container.component.scss' ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ConfirmationContainerComponent implements OnDestroy {
  private readonly destroy$: Subject<void> = new Subject()

  constructor(private readonly routing: ActivatedRoute, private readonly store: Store) {
    this.store.select(selectQueryParam('token')).pipe(
      take(1),
      takeUntil(this.destroy$)
    ).subscribe(token => {
      if (!token) return this.store.dispatch(navigate({ commands: appRoutes.root }))
      this.store.dispatch(verifyAccount({ tokenDto: { token } }))
    })
  }

  public ngOnDestroy(): void {
    this.destroy$.next()
    this.destroy$.complete()
  }

}
